module.exports = __webpack_public_path__ + "static/media/main.c0ad2578.png";